// @ts-check

import React from "react"
import { MultiStateCheckbox } from "../../atoms/MultiStateCheckbox.atom"

/**
 * @param {import("./SelectHeader.molecule").SelectHeaderProps} props
 * @returns {JSX.Element | null}
 */
export function SelectHeader(props) {
  const { ctx } = props
  const { table } = ctx

  const isAllRowsSelected = table.getIsAllRowsSelected()
  const isSomeRowsSelected = table.getIsSomeRowsSelected()

  return (
    <MultiStateCheckbox
      value={
        isAllRowsSelected ? "all"
        : isSomeRowsSelected ?
          "partial"
        : null
      }
      onChange={() => table.toggleAllRowsSelected(!isAllRowsSelected)}
    />
  )
}
